<template>
    <div class="CampsList">
        <filters/>
        <template v-if="campsList && campsList.length">
            <div class="mb-4"
                 v-for="camp of campsList"
                 :key="camp.id"
            >
                <camp-cart
                        :camp="camp"
                        @open="onEnrollButtonClick(camp, $event)"
                />
            </div>
            <pagination/>
        </template>
        <template v-else>
            <no-data-skeleton v-if="!searchQuery"/>
            <template v-else>
                <div class="not-found">
                    <img src="../../../../assets/img/ilustra-empty-search.png">
                    Oh no! We can’t find any activities with that name :|
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import * as types from '@/store/mutationTypes';
    import { mapActions, mapMutations, mapGetters } from 'vuex';

    const ActivityCampSetUpChildModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/ActivityCampSetUpChildModal');

    export default {
        name: 'CampsList',

        components: {
            CampCart: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/CampCart'),
            NoDataSkeleton: () => import(/* webpackChunkName: "activities" */ '@/components/controls/NoDataSkeleton'),
            Pagination: () => import(/* webpackChunkName: "activities" */ '@/components/controls/Pagination'),
            Filters: () => import(/* webpackChunkName: "activities" */ '@/components/controls/Filters')
        },

        props: {
            isPublic: {
                type: Boolean,
                default: false
            },
            isSchool: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            ...mapGetters(['campsList', 'searchQuery'])
        },

        methods: {
            ...mapActions([
                'getCampsBySchool',
                'openModal'
            ]),

            ...mapMutations({
                setCamp: types.SET_ACTIVITY,
                setCampPricing: types.SET_ACTIVITY_CAMP_PRICING
            }),

            openEnrollChildModal(camp, pricing) {
                this.setCamp(camp);
                this.setCampPricing(pricing);
                this.openModal({
                    modal: ActivityCampSetUpChildModal,
                    options: {
                        isSchool: this.isSchool
                    }
                });
            },

            redirectToParentPortal(pricing) {
                const { school } = this.$router.currentRoute.params;
                window.open(`${window.location.origin}/parents/${school}/activities?activeTab=CampsList&pricingId=${pricing.id}`, '_blank');
            },

            onEnrollButtonClick(camp, pricing) {
                this.isPublic ? this.redirectToParentPortal(pricing) : this.openEnrollChildModal(camp, pricing);
            },

            findCampPricingById(id) {
                return _.chain(this.campsList)
                    .flatMap(camp => camp.pricings)
                    .find(pricing => pricing.id === +id)
                    .value();
            },

            findCampByPricing(pricing) {
                return _.find(this.campsList, camp => camp.pricings.includes(pricing));
            }
        },

        async created() {
            const { pricingId } = this.$route.query;
            await this.getCampsBySchool();

            if (pricingId) {
                await this.$nextTick();
                const pricing = this.findCampPricingById(pricingId);
                if (pricing) {
                    const camp = this.findCampByPricing(pricing);
                    this.openEnrollChildModal(camp, pricing);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Activities/CampsList.vue